
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
name: '',
props: {
tabbar: {
type: Array,
default: () => []
}
},
data () {
return {
}
},
components: {
Tabbar,
TabbarItem
},
mounted () {

},
methods: {
isActive: function (item) {
let routerPath = this.$route.path
let itemPath = item.href
return itemPath === routerPath
},
isShow: function () {
return this.$route.meta.tabbar
}
}
}



// WEBPACK FOOTER //
// ./src/components/tabbar.vue